import React from "react";

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string
}

const SkillsTable: React.FC<{ data: group[] }> = ({ data }) => (
    <table className={"table-advice-style"} style={{fontFamily: '源ノ角ゴシック JP', marginTop: '24px'}}>
        <thead>
        <tr>
            <th style={{ width: '30%' }} className={'p-4'}>要因</th>
            <th style={{ width: '8%' }} className={'p-4'}>スコア</th>
            <th style={{ width: '8%' }} className={'p-4'}>偏差値</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, index) => (
            <tr key={index}>
                <td className={'p-4'}><span className={"circle-number-parent"}><span dangerouslySetInnerHTML={{ __html: item.groupTitle || '' }}/></span></td>
                <td className={
                    item.isLowSkill === 'n' ? 'base' : item.isLowSkill === 't' ? 'data-point-red base' : 'data-point-green base'}>{item.totalPoint}</td>
                <td className={
                    item.isLowSkill === 'n' ? 'base' : item.isLowSkill === 't' ? 'data-point-red base' : 'data-point-green base'}>{item.deviation}</td>
                <td className={'data-description'}>{item.exposition}</td>
            </tr>
        ))}
        </tbody>
    </table>
);

export default SkillsTable;
